module.exports = {
    passenger_type_enum: {
        REGULAR: 'regular',
        ADVANCED: 'advanced',
        TECHNICAL: 'technical'
    },

    mission_type_enum: {
        MISSION_TYPE_NONE: 'MISSION_TYPE_NONE',
        MISSION_TYPE_TRANSPORTATION: 'MISSION_TYPE_TRANSPORTATION',
        MISSION_TYPE_CHARGING: 'MISSION_TYPE_CHARGING',
        MISSION_TYPE_SHUTTLE:'MISSION_TYPE_SHUTTLE'
    },

    path_type_enum: {
        PATH_TYPE_NONE: 'PATH_TYPE_NONE',
        PATH_TYPE_TRANSPORTATION_GOTOPICKUP: 'PATH_TYPE_TRANSPORTATION_GOTOPICKUP',
        PATH_TYPE_TRANSPORTATION_PICKUP: 'PATH_TYPE_TRANSPORTATION_PICKUP',
        PATH_TYPE_TRANSPORTATION_GOTODEST: 'PATH_TYPE_TRANSPORTATION_GOTODEST',
        PATH_TYPE_TRANSPORTATION_FINISHED: 'PATH_TYPE_TRANSPORTATION_FINISHED',
        PATH_TYPE_CHARGING_GOTO_STATION: 'PATH_TYPE_CHARGING_GOTO_STATION',
        PATH_TYPE_CHARGING_CONNECTING: 'PATH_TYPE_CHARGING_CONNECTING',
        PATH_TYPE_CHARGING_CHARGING: 'PATH_TYPE_CHARGING_CHARGING',
        PATH_TYPE_CHARGING_FINISHED: 'PATH_TYPE_CHARGING_FINISHED',
        PATH_TYPE_SHUTTLE_GOTO_DEST: 'PATH_TYPE_SHUTTLE_GOTO_DEST',
        PATH_TYPE_SHUTTLE_GOTO_START_POINT: 'PATH_TYPE_SHUTTLE_GOTO_START_POINT',
        PATH_TYPE_SHUTTLE_ARRIVEDTODEST: 'PATH_TYPE_SHUTTLE_ARRIVEDTODEST',
        PATH_TYPE_SHUTTLE_FINISHED: 'PATH_TYPE_SHUTTLE_FINISHED',
    },

    task_type:{
        TRIGGERED_TASK_WAIT:'WaitTask',
        TRIGGERED_TASK_SMS:'SmsTask',
        TRIGGERED_TASK_PLAY_SOUND:'PlaySoundTask',
    },
    path_status_enum:{
        NONE:"NONE",
        READY:"READY",// path received, ready to drive
        DRIVING:"DRIVING", 
        PAUSED:"PAUSED",  //not driving, but has a path and ready to conyinue
        FINISHED:"FINISHED",  //path done, last point aquired
        STOPPED:"STOPPED", //USER STOPPED
        ERROR:"ERROR", //error occoursed, can't drive
        BLOCKED:"BLOCKED" ,//error occoursed, can't drive
        BLOCKED_STABLE:"BLOCKED_STABLE",  //BLOCKED for x (configurable) time
        STUCK : 101, // Can't drive for unknown reason for x (configurable) time
        MALFUNCTION : 102, // Can't drive due to malfunction for x (configurable) time
        OPERATOR_TREATMENT : 103
    },
    event_type_enum:{
        TYPE_SYSTEM_ISSUE:"TYPE_SYSTEM_ISSUE",
        TYPE_OPERATOR_TREATMENT:"TYPE_OPERATOR_TREATMENT",
        TYPE_UNAVAILABLE:"TYPE_UNAVAILABLE",
        TYPE_PATH_STUCK:"TYPE_PATH_STUCK",
        
        ROAD_EVENT:"road_event",
        MULFUNCTION_EVENT:"cart_mulfunction_event",
        CART_UNAVAILABILITY_EVENT:"cart_uavailable_event",

        MISSED_CALL_EVENT:"missed_call_event",
        GENERAL_EVENT:"general_event",
        SERVER_START_EVENT : "server_start_event",
        VOICE_EVENT:"voice_assistance_event",
    },
    event_severity_enum:{
        SEVERITY_LOW:'SEVERITY_LOW',
        SEVERITY_MEDIUM:'SEVERITY_MEDIUM',
        SEVERITY_HIGH:'SEVERITY_HIGH',
    },
    TYPE_SYSTEM_ISSUE:{
        SYSTEM_ISSUE_MALFUNCTION : "SYSTEM_ISSUE_MALFUNCTION", 
        SYSTEM_ISSUE_CONSTRAINT : "SYSTEM_ISSUE_CONSTRAINT", 
        SYSTEM_ISSUE_SW_FAILURE : "SYSTEM_ISSUE_SW_FAILURE",
    },
    TYPE_OPERATOR_TREATMENT:{
        OPERATOR_TREATMENT_COLLISION : "OPERATOR_TREATMENT_COLLISION",
        OPERATOR_TREATMENT_SM_EBRAKE : "OPERATOR_TREATMENT_SM_EBRAKE",
        OPERATOR_TREATMENT_JUNCTION : "OPERATOR_TREATMENT_JUNCTION",
        OPERATOR_TREATMENT_PATH_REJECTED : "OPERATOR_TREATMENT_PATH_REJECTED",
        TEMPORARY_EVENT:"temporary_event", // system event

    },
 
    TYPE_UNAVAILABLE:{
        UNAVAILABLE_DECISION_BRAKE : "UNAVAILABLE_DECISION_BRAKE",
        UNAVAILABLE_BUSY : "UNAVAILABLE_BUSY",
        UNAVAILABLE_VERSION_UPDATING : "UNAVAILABLE_VERSION_UPDATING",
        UNAVAILABLE_NO_DECISION : "UNAVAILABLE_NO_DECISION",
        UNAVAILABLE_RECORD_CUTTING : "UNAVAILABLE_RECORD_CUTTING",
        UNAVAILABLE_STARTUP : "UNAVAILABLE_STARTUP",
    },
    TYPE_PATH_STUCK :{
        PATH_STUCK_BLOCKED :"PATH_STUCK_BLOCKED",
        PATH_STUCK_UNKNOWN_REASON :"PATH_STUCK_UNKNOWN_REASON",
    },
    operation_options_list:{
        OPERATION_WAIT : 'OPERATION_WAIT',
        OPERATION_RESOLVED : 'OPERATION_RESOLVED',
        OPERATION_IGNORE_ISSUE : 'OPERATION_IGNORE_ISSUE',
        OPERATION_IGNORE_BOUNDARY : 'OPERATION_IGNORE_BOUNDARY',
        OPERATION_IGNORE_OBSTACLE : 'OPERATION_IGNORE_OBSTACLE',
        OPERATION_REVERSE : 'OPERATION_REVERSE',
        OPERATION_MANUAL_PLANNING : 'OPERATION_MANUAL_PLANNING',
        OPERATION_SOFT_RESET : 'OPERATION_SOFT_RESET',
        OPERATION_HARD_RESET : 'OPERATION_HARD_RESET',
        OPERATION_READ_TIP : 'OPERATION_READ_TIP',
        OPERATION_OPEN_CAMERAS : 'OPERATION_OPEN_CAMERAS',
        OPERATION_CALL_USER : 'OPERATION_CALL_USER',

        OPERATION_PAUSE:   'PAUSE', // junction inner controll events
        OPERATION_DRIVE:    'DRIVE', // junction inner controll events
    },
    mapping_app_point_type_enum: {
        POI: 'POI',
        MEMO: 'MEMO',
        STOP_LINE: 'STOP_LINE',
        BOUNDARY: 'BOUNDARY',
        ROAD: 'RAOD',
        CROSSWALK:'CROSSWALK'
    },

}